import { Component, EventEmitter, Input, Output } from "@angular/core";
import { UiKitModule } from "@app/ui-kit.module";

@Component({
  selector: "app-toggle-item-text-visibility-button",
  imports: [UiKitModule],
  templateUrl: "./toggle-item-text-visibility-button.component.html",
  styleUrl: "./toggle-item-text-visibility-button.component.scss",
})
export class ToggleItemTextVisibilityButtonComponent {
  @Input({ required: true }) itemTextVisible!: boolean;
  @Input() isSingleItem: boolean = false;
  @Output() toggleEvent = new EventEmitter<boolean>();

  protected readonly tooltipTextShowCategory: string = $localize`:@@floorplan.button.showItemText:Beschriftungen einblenden`;
  protected readonly tooltipTextHideCategory: string = $localize`:@@floorplan.button.hideItemText:Beschriftungen ausblenden`;

  toggleItemTextVisibility() {
    this.itemTextVisible = !this.itemTextVisible;
    this.toggleEvent.emit(this.itemTextVisible);
  }
}
